import PropTypes from "prop-types"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, Consentement, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useUrlReturn } from "hooks"
import { consent, defaultValues, getCampus } from "services"

const Form = ({ parent = false }) => {
  const campaignId = parent ? '701Tx00000XPex3IAD' : '701Tx00000ZMBlVIAX'
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
    const { url } = useUrlReturn('EART-LB-PARENT')
    const { url: url_etudiant } = useUrlReturn('EART-LB-ETUDIANT')
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      campaignId: campaignId,
      lead: {
        ...defaultValues,
        AcademicLevel__c: parent ? 'Autre': '',
        MobilePhone: '',
        Salutation: ''
      },
    },
    resolver: yupResolver(schema, { context: { parent } })
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'e-artsup',
      IONISSchool__c: 'e-artsup',
      LastForm__c: parent ? 'Documentation PDF - LB Parents' : 'Documentation PDF - LB Etudiants',
      LeadSource: 'Internet: Demande de doc',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      const leadCreated = await salesforce.createLead(finalLead)
      const campaignMember = {
        CampaignId: campaignId,
        LeadId: leadCreated.Id,
        Status: 'Active'
      }
      await salesforce.createCampaignMember(campaignMember)
      if (parent) {
        document.location.href=`${url}?ville=${campus}&campaignId=${campaignId}`
      } else {
        document.location.href=`${url_etudiant}?ville=${campus}&campaignId=${campaignId}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('BusinessSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        {!parent && (
          <AcademicLevel school="e-artsup" section={false} specialites={false} />
        )}
        <Grid item sm={12} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone mobile" required />
        </Grid>
        <Campus label="Campus d’intérêt" options={getCampus('e-artsup')} />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Livre Blanc" school="e-artsup" />
      </Grid>
    </FormProvider>
  )
}

Form.propTypes = {
  parent: PropTypes.bool
}

export default Form
